import React, { useState } from 'react';

import {
  useGetUsersListQuery,
  type GetUsersListParams,
} from 'features/users';

import { UsersFilter, UsersTable, FilterValues } from 'widgets/users';


const defaultPageSize = 30;

const initParams = {
  page: 1,
  pageSize: defaultPageSize,
};

const Users = () => {
  const [params, setParams] = useState<GetUsersListParams>(initParams);

  const {
    usersList,
    usersCount,
    isUsersFetching,
  } = useGetUsersListQuery(params, {
    selectFromResult: ({ data, isFetching, isError }) => ({
      usersList: data?.items ?? [],
      usersCount: data?.count ?? 0,
      isUsersFetching: isFetching,
      isUsersError: isError,
    })
  });

  const handleFilterChange = (formData: FilterValues) => {
    setParams((prev) => ({
      ...formData,
      page: 1,
      pageSize: prev.pageSize
    }));
  };

  const handleFilterReset = () => {
    setParams((prev) => ({
      ...initParams,
      pageSize: prev.pageSize,
    }));
  };

  const handlePaginationChange = (page: number, pageSize: number) => {
    setParams((prev) => ({
      ...prev,
      page,
      pageSize,
    }));
  };

  return (
    <div>
      <UsersFilter
        onSubmit={handleFilterChange}
        onReset={handleFilterReset}
        userId={params.id}
      />
      <UsersTable
        items={usersList}
        itemsTotal={usersCount}
        currentPage={params.page}
        defaultPageSize={defaultPageSize}
        onPageChange={handlePaginationChange}
        isLoading={isUsersFetching}
      />
    </div>
  );
};

export default Users;
